<template>
  <organisation-registration-form
    v-if="isOrganisationForm"
    class="registration-form"
  />
  <registration-form v-else class="registration-form" />
</template>

<script>
export default {
  name: "App",
  computed: {
    isOrganisationForm() {
      let registrationFormEntry = document.querySelector("registration-form-entry");
      let entityType =
        registrationFormEntry && registrationFormEntry.getAttribute("entity-type");
      // entity-type carries the raw RegistrationFormEntityType enum value
      // ("Person" | "Club" | "ExternalOrganisation") - there is no literal
      // "Organisation" value. FoysRegistrationForm.vue only emits the
      // attribute at all for non-Person forms, so match explicitly against
      // the two organisation-flavoured values rather than the attribute's
      // mere presence.
      return entityType === "Club" || entityType === "ExternalOrganisation";
    },
  },
};
</script>